import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'
import { activeLanguage } from '@/composables/globalData/useLanguages'
import { BaseWidgetTemplate, TemplatesCategoryData } from '@/types/templates'
import { DashboardTemplateCategoryList as IDashboardTemplateCategoryList } from '@/types/dashboard-template'
import { TemplateHelp } from '@/types/template-help'

export interface CategoryDataResponse {
    CategoryList: Array<TemplatesCategoryData>
    LanguageID: number
    Status: number
    TemplateList: Array<BaseWidgetTemplate>
}

export interface DashboardTemplateListResponse {
    DashboardTemplateCategoryList: Array<IDashboardTemplateCategoryList>
}

export interface WidgetTemplateHelpResponse {
    Data: Array<TemplateHelp>
    Description: string
    Status: number
}

export const templateApi = {
    async getTemplatesAndCategories (): Promise<CategoryDataResponse | undefined> {
        try {
            return await $axios.post('TemplatesCategory/CategoryData/', {})
        } catch (e) {
            parseCatch(e, true, 'Get Templates Category')
        }
    },
    async getDashboardTemplates (): Promise<Array<IDashboardTemplateCategoryList>> {
        try {
            const { DashboardTemplateCategoryList = [] } = await $axios.get(`DashboardTemplate/DashboardTemplateList/${activeLanguage.value.LanguageID}`) as DashboardTemplateListResponse
            return DashboardTemplateCategoryList
        } catch (e) {
            parseCatch(e, true, 'Get Dashboard Templates')
            const { DashboardTemplateCategoryList } = await $axios.get('DashboardTemplate/DashboardTemplateList/1') as DashboardTemplateListResponse
            return DashboardTemplateCategoryList
        }
    },
    async getHelpByWidgetsTemplateID (templateID: number, LanguageID: number): Promise<Array<IDashboardTemplateCategoryList> | undefined> {
        try {
            const { DashboardTemplateCategoryList = [] } = await $axios.get(`DashboardTemplate/DashboardTemplateList/${templateID}/${LanguageID}`) as DashboardTemplateListResponse
            return DashboardTemplateCategoryList
        } catch (e) {
            parseCatch(e, true, 'Template Dictionary')
        }
    },
    async getWidgetsTemplateHelps () {
        try {
            const { Data = [] } = await $axios.get(`WidgetsTemplate/Help/${activeLanguage.value.LanguageID}`) as WidgetTemplateHelpResponse
            return Data
        } catch (e) {
            parseCatch(e, true, 'Template Helps')
        }
    },
}
